import React, {useContext} from "react";
import { AdvancedImage, responsive } from "@cloudinary/react";
import {ProjectsContext} from "../../App";
import "./style.scss";

const Laurels = ({ laurels }) => {
    const { cld } = useContext(ProjectsContext);

    return (
        <div className="laurels">
            {laurels.map((laurel, index) => (
                <AdvancedImage
                    key={index}
                    cldImg={cld.image(laurel.public_id)}
                    plugins={[responsive({ steps: 200 })]}
                    className="laurel"
                />
            ))}
        </div>
    );
};

export default Laurels;

